import React, { ReactNode, useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { useAccount } from "../../../store/account/hooks";
import { useRoutes } from "../../../store/routes/hooks";
import { useTranslation } from "react-i18next";
import { styles } from "../../../styles";
import { P } from "../../common/Typography";
import { PageSection } from "./Dashboard";
import { isMobile } from "../../../services/helpers.service";

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 48px);
  position: fixed;
  top: 0;
  left: 0;
  background: ${styles.colors.white};
  z-index: 1000;

  p {
    max-width: 50%;
    text-align: center;
  }
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid ${styles.colors.darkBlue};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const DashboardGuard = (props: { children: ReactNode }) => {
    return (
        <>
            <AuthenticationMiddleware>{props.children}</AuthenticationMiddleware>
        </>
    );
};

const AuthenticationMiddleware = (props: { children: ReactNode }) => {
    const { isAuthenticated, isLoading, checkAuthentication } = useAccount();
    const { t } = useTranslation() as any;
    const { Routes } = useRoutes() as any;
    const history = useHistory();

    useEffect(() => {
        checkAuthentication();
    }, [checkAuthentication]);

    useEffect(() => {
        if (!isLoading && !isAuthenticated) history.push(Routes.HOME);
    }, [isAuthenticated, isLoading, history, Routes.HOME]);

    if (isLoading) return (
        <PageSection>
            <LoadingContainer>
                <Spinner />
                <P>{t('account.loading')}...</P>
            </LoadingContainer>
        </PageSection>
    );
    if (!isAuthenticated) return null;

    if (isMobile()) {
        return (<PageSection>
            <LoadingContainer>
                <P>{t('account.mobile')}</P>
            </LoadingContainer>
        </PageSection>)
    };

    return <>{props.children}</>;
};
